import t from "../locales";
import SaveInfoTooltip from "./save_info_tooltip";

import heartIcon from "../assets/images/you_share/favorite.svg";
import downloadIcon from "../assets/images/you_share/file_download.svg";
import savedIcon from "../assets/images/you_share/file_saved.svg";
import { usePicturesStore } from "../store/pictures";
import { useState } from "react";

const hashtagElement = (h) => {
  if (h.saveInNotepad) {
    return (
      <SaveInfoTooltip name={h.saveInNotepad} key={h.label}>
        <span className="you-share-hashtag">{t(h.label)}</span>
      </SaveInfoTooltip>
    );
  } else {
    return (
      <span className="you-share-hashtag" key={h.label}>
        {h.label}
      </span>
    );
  }
};

export default function YouShareImageCard({ picture }) {
  const savePicture = usePicturesStore((state) => state.savePicture);
  const savedPictures = usePicturesStore((state) => state.savedPictures);
  const saved = savedPictures.includes(picture.key);

  const [showTooltip, setShowTooltip] = useState(false);

  const save = () => {
    savePicture(picture.key);
    setTimeout(() => setShowTooltip(false), 2000);
  };

  return (
    <div id={picture.key}>
      <img src={picture.file} alt="" />
      <div className="you-share-picture-info">
        <div className="you-share-picture-icons">
          <img src={heartIcon} />
          <span className="tooltip">
            <button
              onClick={() => setShowTooltip(true)}
              className="tooltip__trigger"
            >
              <img src={saved ? savedIcon : downloadIcon} />
            </button>
            {showTooltip && (
              <div className="tooltip__tip tooltip__tip--left">
                {saved ? (
                  t("tooltip_saved")
                ) : (
                  <button className="tooltip__button" onClick={save}>
                    {t("tooltip_save_in_youfind")}
                  </button>
                )}
              </div>
            )}
          </span>
        </div>
        <div className="you-share-comment">{t(picture.comment)}</div>
        <div className="you-share-hashtags">
          {picture.hashtags.map((h) => hashtagElement(h))}
        </div>
      </div>
    </div>
  );
}
